<template>
  <section>
    <!-- <TemplateOne v-if="selectedTemplate == '6603aa48c4e3c926bc59563f'"></TemplateOne>
    <TemplateTwo v-if="selectedTemplate == '6603aa86c4e3c926bc595642'"></TemplateTwo> -->
        <TemplateOne v-if="selectedTemplate == '6603aa48c4e3c926bc59563f'" @idtemplatechanged="updatedidtemplate" ></TemplateOne>
        <TemplateTwo v-if="selectedTemplate == '6627817e5861fd1c20a4c67c'" @idtemplatechanged="updatedidtemplate"></TemplateTwo>
        <TemplateThree v-if="selectedTemplate == '662411ad5861fd1c20a4bcf1'" @idtemplatechanged="updatedidtemplate"></TemplateThree>
        <TemplateFour v-if="selectedTemplate == '662b67eb5861fd1c20a4dbb8'" @idtemplatechanged="updatedidtemplate"></TemplateFour>
        <TemplateFive v-if="selectedTemplate == '662b67c45861fd1c20a4dbb3'" @idtemplatechanged="updatedidtemplate"></TemplateFive>
  </section>

</template>

<script>
import TemplateOne from "@/views/components/SmartCardTemplate/TemplateOne/TemplateOne"
import TemplateTwo from "@/views/components/SmartCardTemplate/TemplateTwo/TemplateTwo"
import TemplateThree from "@/views/components/SmartCardTemplate/TemplateThree/TemplateThree"
import TemplateFour from "@/views/components/SmartCardTemplate/TemplateFour/TemplateFour"
import TemplateFive from "@/views/components/SmartCardTemplate/TemplateFive/TemplateFive"

export default {
  name: "smartCard",
  data() {
    return {
      selectedTemplate:  "6603aa48c4e3c926bc59563f",
    }
  },methods:{
      updatedidtemplate(idtemplate){
        this.selectedTemplate = idtemplate
        // console.log('receiving selectedTemplate 1 is :', this.selectedTemplate === '6603aa48c4e3c926bc59563f')
        // console.log('receiving selectedTemplate 2 is :', this.selectedTemplate === '6603aa86c4e3c926bc595642')
      }
  },
  components: {
    TemplateOne, 
    TemplateTwo,
    TemplateThree,
    TemplateFour,
    TemplateFive
  },
  async created() {
    this.$store.state.hideConfigButton = true;
    this.$store.state.showNavbar = false;
    this.$store.state.showSidenav = false;
    this.$store.state.showFooter = false;  
    // console.log("other way to get id using store : ",this.$store.state.selectedTemplateId)
  },
};
</script>

<style scoped lang="scss">

</style>